import {useFetch} from "./fetch";
import {
    ChangePasswordRequest,
    RegisterRequest,
    ResetRequest,
    UpdatePasswordRequest,
    User,
    VerifyRequest
} from "../models/auth";
import {UseFetchReturn, MaybeComputedRef} from "@vueuse/core";

export function useRegister(request: RegisterRequest): UseFetchReturn<null> {
    return useFetch<null>("authentication/register", {immediate: false})
        .post(request)
}


export function useVerify(request: VerifyRequest): UseFetchReturn<null> {
    return useFetch<null>("authentication/verify")
        .post(request)
}

export function useReset(request: ResetRequest): UseFetchReturn<null> {
    return useFetch<null>("authentication/reset")
        .post(request)
}


export function useChangePassword(request: ChangePasswordRequest): UseFetchReturn<null> {
    return useFetch<null>("authentication/change", {immediate: false})
        .post(request)
}

export function useUser(): UseFetchReturn<User> {
    return useFetch<User>("user")
        .get()
        .json()
}

export function useUpdatePassword(request: MaybeComputedRef<UpdatePasswordRequest>): UseFetchReturn<null> {
    return useFetch<null>("user/changePassword", {immediate: false})
        .post(request, 'json')
}